import React, { createContext, useCallback, useContext, useState } from "react";

import UserContext                                                 from "~/contexts/UserContext";
import useTwilioInit                                               from "~/hooks/useTwilioInit/index.web";
import { useCallDuration }                          from "~/hooks/useCallDuration";
import NumbersContext                                              from '~/contexts/NumbersContext';

export const TwilioContext = createContext({});

export function TwilioProvider({ children }) {
  const { user } = useContext(UserContext);
  const { activeNumber } = useContext(NumbersContext);

  const {
    device,
    activeCall,
    callState,
    callStatus,
    token,
    dispatch,
    startDeviceCall,
    endDeviceCall,
  } = useTwilioInit(user?.id);

  const [destination, setDestination] = useState({});

  // Function that starts an outgoing call
  const startCall = useCallback(
    async (to, metaData = {}) => {
      const { phone_number: from } = activeNumber;

      if (from) {
        try {
          setDestination({ phoneNumber: to, participant: { ...metaData } });
          startDeviceCall({ to, from });
        } catch (e) {
          console.log(e);
        }
      } else {
        console.error("Attempting to make call with no assignedNumber ");
      }
    },
    [activeNumber, activeCall, callState]
  );

  const toggleMute = useCallback(
    (mute) => {
      if (activeCall) {
        // TwilioPhone.toggleMuteCall(activeCall.callSid, mute);
        activeCall.mute(mute);
      } else {
        console.error("Cannot mute call without an active call");
      }
    },
    [activeCall]
  );

  // Not needed for web. NOOP
  const toggleSpeaker = useCallback(()=>{},[]);

  const sendDigits = useCallback(
    (digits) => {
      if (activeCall) {
        activeCall.sendDigits(`${ digits }`);
      } else {
        console.warn("Cannot send digits without an active call");
      }
    },
    [activeCall]
  );

  // Function that ends a call
  const endCall = useCallback(async () => {
    try {
      setDestination({});
      await endDeviceCall();
    } catch (e) {
      console.log(e);
    }
  }, [device, activeCall, endDeviceCall]);

  const { duration, callDuration } = useCallDuration(activeCall);

  return (
    <TwilioContext.Provider
      value={{
        destination,
        callState,
        activeCall,
        startCall,
        endCall,
        token,
        sendDigits,
        toggleMute,
        toggleSpeaker,
        duration,
        callDuration,
        callStatus,
      }}
    >
      {children}
    </TwilioContext.Provider>
  );
}

export default TwilioContext;
